<template>
  <TopMenuStyle>
 
  <sdDropdown>
    <template #overlay>

      <router-link to="/centers" v-if="disCenter"><span>Add region</span></router-link>
      <router-link to="/users" v-if="disUser"><span>Add user</span></router-link>
      <router-link to="/roles" v-if="disRole"><span>Add role</span></router-link>
      <router-link to="/assign"><span >Assign/Reassign leads</span></router-link>
      <router-link to="/new"  v-if="dispLead"><span >New leads</span></router-link>
      <router-link to="/fresh-data"><span >Add contacts</span></router-link>
      <router-link to="/data-update"><span >Update contacts</span></router-link>
      <router-link to="/clicks-update"><span >Add Clicks/Opens</span></router-link>
      <router-link to="/email-dashboard"  v-if="dispEmail"><span >Email Marketing Dashboard</span></router-link>
      <router-link to="/digital-dashboard"  ><span >Digital Marketing Dashboard</span></router-link>
    </template>
      <router-link to="#" style="color:#ffffff;font-size: 16px;">Administrator <sdFeatherIcons type="chevron-down" size="16" style="color:#ffffff; margin-right:20px !important;"/></router-link>
  </sdDropdown>
  <sdDropdown>
    <template #overlay>
      <router-link to="/" v-if="disTask"><span >Dashboard</span></router-link>
      <router-link to="/search" v-if="dispSearch"><span >Search Leads</span></router-link>
      <router-link to="/new-leads"><span >Add lead</span></router-link>
      <!--<router-link to="/opnsprint/12"><span >Mailchimp</span></router-link>-->
    </template>
      <router-link to="#" style="color:#ffffff;font-size: 16px;">Sales Leads Process <sdFeatherIcons type="chevron-down" size="16" style="color:#ffffff; margin-right:20px !important;"/></router-link>
  </sdDropdown>
  <!--<sdDropdown>
    <template #overlay>
      <router-link to="/daily"><span >New Database Additions Report</span></router-link>
      <router-link to="/status"><span >Leads Assigned to Individuals Report</span></router-link>
      <router-link to="/select-status"><span >Leads Individual Status Report</span></router-link>
      <router-link to="/status-changed"><span >Leads Status changed over a period Report</span></router-link>
      <router-link to="/follow-up"><span >Leads Pending Follow-ups in a period Report</span></router-link>
      <router-link to="/clicks-tag"><span >Daily Leads Tagged Report</span></router-link>
      <router-link to="/mis-report"><span >Calls Tagged Count Report</span></router-link>
      <router-link to="/inbound-leads"><span >Inbound Leads Report</span></router-link>
      <router-link to="/sales-funnel" ><span >Sales Funnel Report</span></router-link>
      <router-link to="/deal-won" ><span >Deals Won Report</span></router-link>
      <router-link to="/dead-proposal" ><span >Leads lost after Meeting Completed (Proposal Stage).</span></router-link>
      <router-link to="/dead-leads" ><span>Leads Lost in lead generation stages.</span></router-link>
      <router-link to="/sales-tracking" ><span >Sales Tracking Report</span></router-link>
      <router-link to="/sales-status-tracking" ><span >Sales & Status Tracking Report</span></router-link>
      <router-link to="/calls-tracking" ><span >Calls Tracking Report</span></router-link>

    </template>
      <router-link to="#" style="color:#ffffff;font-size: 16px;" v-if="disReport">Reports <sdFeatherIcons type="chevron-down" size="16" style="margin-top: 100px; color:#ffffff; margin-right:20px !important;"/></router-link>
  </sdDropdown>-->
  <sdDropdown placement="bottomLeft">
    <template #overlay>
      <a-menu mode="vertical">

        <!-- SALES TEAM -->
        <a-sub-menu
          key="sales"
          v-if="reportAccess.sales"
        >
          <template #title>
            Sales Reports
          </template>

          <a-menu-item key="sales-funnel">
            <router-link to="/sales-funnel">
              Sales Funnel Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="deal-won">
            <router-link to="/deal-won">
              Deals Won Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="dead-proposal">
            <router-link to="/dead-proposal">
              Leads Lost After Meeting Completed
            </router-link>
          </a-menu-item>

          <a-menu-item key="sales-tracking">
            <router-link to="/sales-tracking">
              Sales Tracking Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="sales-status-tracking">
            <router-link to="/sales-status-tracking">
              Sales & Status Tracking Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="sales-won">
            <router-link to="/sales-won">
              Sales Won Report
            </router-link>
          </a-menu-item>
          <a-menu-item key="managers-pipeline">
            <router-link to="/managers-pipeline">
              Managers Pipeline Review Report
            </router-link>
          </a-menu-item>
          <a-menu-item key="sales-lost">
            <router-link to="/sales-lost">
              Sales Lost Review Report
            </router-link>
          </a-menu-item>
          <a-menu-item key="no-show">
            <router-link to="/no-show">
              No Show Review Report
            </router-link>
          </a-menu-item>
          <a-menu-item key="individual-pipeline">
            <router-link to="/individual-pipeline">
              Individual Pipeline Review Report
            </router-link>
          </a-menu-item>
          
        </a-sub-menu>

        <!-- LEAD GENERATION -->
        <a-sub-menu
          key="leadgen"
          v-if="reportAccess.leadGen"
        >
          <template #title>
            Lead Generation Reports
          </template>

          <a-menu-item key="calls-tracking">
            <router-link to="/calls-tracking">
              Calls Tracking Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="dead-leads">
            <router-link to="/dead-leads">
              Leads Lost in Lead Generation Stages
            </router-link>
          </a-menu-item>
          <a-menu-item key="lead-generation-report">
            <router-link to="/lead-generation-report">
              Lead Generation Report
            </router-link>
          </a-menu-item>
          <a-menu-item key="opportunity-created">
            <router-link to="/opportunity-created">
              Opportunity Created Report
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <!-- DATA TEAM -->
        <a-sub-menu
          key="data"
          v-if="reportAccess.data"
        >
          <template #title>
            Data Team Reports
          </template>

          <a-menu-item key="daily">
            <router-link to="/daily">
              New Database Additions Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="inbound-leads">
            <router-link to="/inbound-leads">
              Inbound Leads Report
            </router-link>
          </a-menu-item>
        </a-sub-menu>

        <!-- OTHERS -->
        <a-sub-menu
          key="others"
          v-if="reportAccess.others"
        >
          <template #title>
            Others Reports
          </template>

          <a-menu-item key="status">
            <router-link to="/status">
              Leads Assigned to Individuals Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="select-status">
            <router-link to="/select-status">
              Leads Individual Status Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="status-changed">
            <router-link to="/status-changed">
              Leads Status Changed Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="follow-up">
            <router-link to="/follow-up">
              Pending Follow-ups Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="clicks-tag">
            <router-link to="/clicks-tag">
              Daily Leads Tagged Report
            </router-link>
          </a-menu-item>

          <a-menu-item key="mis-report">
            <router-link to="/mis-report">
              Calls Tagged Count Report
            </router-link>
          </a-menu-item>
        </a-sub-menu>

      </a-menu>
    </template>

    <router-link
      to="#"
      style="color:#fff;font-size:16px"
      v-if="disReport"
    >
      Reports
      <sdFeatherIcons
        type="chevron-down"
        size="16"
      />&nbsp;&nbsp;
    </router-link>
  </sdDropdown>
   <!--<sdDropdown>
    <template #overlay>
      <router-link to="#"><span >Campaign Data Upload</span></router-link>
      <router-link to="#"><span >Campaign data downloads</span></router-link>
    </template>
      <router-link to="#" style="color:#ffffff;font-size: 16px;">Campaign <sdFeatherIcons type="chevron-down" size="16" style="margin-top: 100px; color:#ffffff; margin-right:20px !important;"/></router-link>
  </sdDropdown>-->
  <sdDropdown>
    <template #overlay>
      <router-link to="/send-rfp"><span >Send Request for Proposal</span></router-link>
    </template>
      <router-link to="#" style="color:#ffffff;font-size: 16px;">RFP Questionnaire<sdFeatherIcons type="chevron-down" size="16" style="margin-top: 100px; color:#ffffff; margin-right:20px !important;"/></router-link>
  </sdDropdown>
  </TopMenuStyle>
</template>
<script>
import { onMounted, defineComponent,ref} from "vue";
import { useStore } from "vuex";
import VueTypes from 'vue-types';
import { useRouter } from "vue-router";
import { TopMenuStyle } from "./style";
import Dropdown from "../components/dropdown/Dropdown";
export default defineComponent({
  name: "TopMenu",
  props:["currentuser"],
  watch: {
    currentuser: function (newVal, oldVal) {
      // watch it
     
    },
  },
  components: {
    TopMenuStyle,
    Dropdown,
  },
  setup() {
  var disCenter = ref(false);
    var disRole = ref(false);
    var disUser = ref(false);
    var disReport = ref(false);
    var disTask = ref(false);
    var dispSearch = ref(false);
    var dispLead = ref(false);
    var dispEmail = ref(false);
    var dispSalesFunnel = ref(false);
    var currentuser = JSON.parse(localStorage.getItem("user"));
    onMounted(() => {
      disNav();
      disNav1();
      disNav2();
      const active = document.querySelector(".strikingDash-top-menu a.active");
      const activeDefault = () => {
        const megaMenu = active.closest(".megaMenu-wrapper");
        const hasSubMenuLeft = active.closest(".has-subMenu-left");
        if (!megaMenu) {
          active.closest("ul").previousSibling.classList.add("active");
          if (hasSubMenuLeft)
            hasSubMenuLeft
              .closest("ul")
              .previousSibling.classList.add("active");
        } else {
          active
            .closest(".megaMenu-wrapper")
            .previousSibling.classList.add("active");
        }
      };

      window.addEventListener("load", active && activeDefault);
      
      // return () => window.removeEventListener('load', activeDefault);
    });
    
    const addParentActive = (event) => {
      document.querySelectorAll(".parent").forEach((element) => {
        element.classList.remove("active");
      });

      const hasSubMenuLeft = event.currentTarget.closest(".has-subMenu-left");
      const megaMenu = event.currentTarget.closest(".megaMenu-wrapper");
      if (!megaMenu) {
        event.currentTarget
          .closest("ul")
          .previousSibling.classList.add("active");
        if (hasSubMenuLeft)
          hasSubMenuLeft.closest("ul").previousSibling.classList.add("active");
      } else {
        event.currentTarget
          .closest(".megaMenu-wrapper")
          .previousSibling.classList.add("active");
      }
    };
    const disNav_old = () => {
     let role = JSON.parse(localStorage.getItem("usr_role"));
      if ( role.role_id=="2") {
            disCenter.value=true;
            disRole.value=true;
            disUser.value=true;
            disReport.value=true;
            disTask.value=true;
            dispSearch.value=true;
            dispSalesFunnel.value=false;
      }
      else if(role.role_id=="1"){
            disCenter.value=true;
            disRole.value=true;
            disUser.value=true;
            disReport.value=true;
            disTask.value=true;
            dispSearch.value=true;
            dispSalesFunnel.value=true;
      }
      else if(role.role_id=="3") {
        disTask.value=true;
        dispSearch.value=true; 
        dispSalesFunnel.value=false;
      }
      else if (role.role_id=="4" || role.role_id=="5"){
            disCenter.value=false;
            disRole.value=false;
            disUser.value=false;
            disReport.value=false;
            disTask.value=false;
            dispSearch.value=true;
            dispSalesFunnel.value=false;
      }
    };
    const reportAccess = ref({
      data: false,
      leadGen: false,
      sales: false,
      others: false,
    });

    const disNav = () => {
      let role = JSON.parse(localStorage.getItem("usr_role"));

      // Reset
      reportAccess.value = {
        data: false,
        leadGen: false,
        sales: false,
        others: false,
      };

      if (role.role_id == "1") {
        // Admin
        disCenter.value = true;
        disRole.value = true;
        disUser.value = true;
        disReport.value = true;
        disTask.value = true;
        dispSearch.value = true;
        dispSalesFunnel.value = true;
        reportAccess.value.data = true;
        reportAccess.value.sales = true;
        reportAccess.value.leadGen = true;
        reportAccess.value.others = true;
      }
      else if (role.role_id == "2") {
        // Sales Manager
        disCenter.value = true;
        disRole.value = true;
        disUser.value = true;
        disReport.value = true;
        disTask.value = true;
        dispSearch.value = true;
        dispSalesFunnel.value = false;

        reportAccess.value.sales = true;
        reportAccess.value.others = true;
      }
      else if (role.role_id == "3") {
        // Lead Generation Team
        disTask.value = true;
        dispSearch.value = true;
        disReport.value = true;

        reportAccess.value.leadGen = true;
      }
      else if (role.role_id == "4" || role.role_id == "5") {
        // Data Team
        disCenter.value = false;
        disRole.value = false;
        disUser.value = false;
        disTask.value = false;
        dispSearch.value = true;
        disReport.value = true;

        reportAccess.value.data = true;
      }
    };
    const disNav1 = () => {
     let user = JSON.parse(localStorage.getItem("user1"));
     if (user.user_id=="Dhiraj_P" || user.user_id=="Deepak_S" || user.user_id=="Prathamesh_p") {
         dispLead.value=true;
      } 
      else {
        dispLead.value=false;
      }
    };
    const disNav2 = () => {
     let user = JSON.parse(localStorage.getItem("user1"));
     if (user.user_id=="Govind_G" || user.user_id=="Sonali_T" || user.user_id=="Prathamesh_P" ) {
         dispEmail.value=true;
      } 
      else {
        dispEmail.value=false;
      }
    };
    return { 
    addParentActive,
    disCenter,
    disRole,
    disUser,
    disReport,
    disTask,
    dispSearch,
    dispLead,
    dispEmail,
    dispSalesFunnel,
    disNav,
    disNav1,
    disNav2,
    disNav_old,
    reportAccess,
    };
  },
});
</script>
